import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'api';
import { useAuthState } from 'state/useAuthState';
import { MembershipSource } from 'shared/types';
import { PlanCode } from 'features/membership/membership.constants';

type HostedLink = {
  hostedLink?: string;
  iosSubscription?: boolean;
  dateActiveUntil: string;
  planCode: PlanCode;
  purchaseSource: MembershipSource;
};

type UseMembershipManagement = {
  hostedLink?: string;
  isIosSubscription: boolean;
  dateActiveUntil?: string;
  planCode?: PlanCode;
  purchaseSource?: MembershipSource;
  isLoading: boolean;
  isError: boolean;
};

const getMembershipManagement = (): Promise<AxiosResponse<HostedLink>> =>
  API.get('recurly_integration/hosted_management/');

export const useMembershipManagement = (): UseMembershipManagement => {
  const { hasActiveMembership, user } = useAuthState();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['management-link', user?.supporterStatus?.planType],
    queryFn: getMembershipManagement,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: hasActiveMembership,
  });

  const hostedLink = data?.data?.hostedLink;
  const isIosSubscription = Boolean(data?.data?.iosSubscription);
  const dateActiveUntil = data?.data?.dateActiveUntil;
  const planCode = data?.data?.planCode;
  const purchaseSource = data?.data?.purchaseSource;

  return {
    hostedLink,
    isIosSubscription,
    dateActiveUntil,
    planCode,
    purchaseSource,
    isLoading,
    isError,
  };
};
